<template lang="pug">
.supercharged-entertainment-container
  .check-balance__container
    .my-account-navigation
      ul
        li(v-for="item in menu" :class="{ active: active(item.key) }")
          a(href="" @click.prevent="select(item.key)") {{ item.title }}
  component(:is="`${selected}-tab`" v-bind="cardComponentAttrs")
</template>

<script>
import {getQS} from '../../lib/utils'
const qs = getQS() || {}
const defaultTab = qs.giftcard ? 'giftcard' : null

import PagesMixin from '../../components/_mixins/pages'
import ConfigMixin from '../../components/_mixins/config'
import GiftcardTab from './giftcard'

const components = {
  GiftcardTab,
}

const menu = [
  { key: 'giftcard', title: 'Check gift card balance' },
]

try {
  require('marketing/playcards/_mixins/playcard-list')

  components.PlaycardTab = require('./playcard').default
  menu.splice(0, 0, { key: 'playcard', title: 'Check {{PLAYCARD}} balance' })
} catch (e) {}


export default {
  name: 'page-check-balance',
  settings: 'page.check-balance',
  translations: 'page.check-balance',
  components,

  mixins: [
    PagesMixin,
    ConfigMixin,
  ],

  data: () => ({
    selected: null,
  }),
  computed: {
    menu() {
      const menuSettings = this.$$s('menu', {})
      const menus = menu.filter(({key}) =>  {
        return menuSettings[key] !== false
      })
      return this.translateProductName(menus, ['title'])
    },
    cardComponentAttrs() {
      return {
        ...(this.$$s(this.selected) || {})
      }
    }
  },
  created() {
    this.selected = defaultTab || this.menu[0].key
  },

  methods: {
    select(item) {
      this.selected = item
    },
    active(item) {
      return this.selected === item
    },
  },
}
</script>

<style lang="scss">
.supercharged-entertainment-container {
  .check-balance__container .my-account-navigation {
    margin: auto;
  }

  .check-card {
    input.check-card__inp {
      font-size: 18px;
      line-height: 1;
      color: white;
      font-family: 'OpenSans-SemiBold', sans-serif;
      height: auto;
      padding-left: 0;
      border: none;
      border-bottom: 1px solid #fff;
      &.number {
        width: calc(70% - 10px);
        margin-right: 10px;
      }
      &.code {
        width: calc(30% - 10px);
        margin-left: 10px;
      }
    }
  }
}
</style>
